<label class="visually-hidden" [attr.for]="labelId">{{ label }}</label>
<ng-select
  [labelForId]="labelId"
  [items]="districtList | async"
  bindLabel="title"
  [multiple]="true"
  [closeOnSelect]="false"
  [hideSelected]="false"
  [ngModel]="internalSelectedDistrictList"
  (change)="onSelectionChange($event)"
  (search)="onSearch($event)"
  [loading]="searchLoading"
  [placeholder]="placeholder"
  [clearable]="clearable">
  <ng-template ng-header-tmp>
    <div class="d-flex align-items-center gap-2">
      <button
        type="button"
        class="btn btn-link btn-sm p-0"
        [disabled]="selectAllLoading"
        (click)="selectAllDistricts()">
        Select All
      </button>
      <button
        type="button"
        class="btn btn-link btn-sm p-0"
        [disabled]="!internalSelectedDistrictList.length"
        (click)="clearAllDistricts()">
        Clear All
      </button>
      <span
        *ngIf="internalSelectedDistrictList.length"
        class="ms-auto fs-14 text-muted">
        {{ internalSelectedDistrictList.length }} selected
      </span>
    </div>
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-item$="item$"
    let-index="index">
    <input
      [id]="'district-option-' + index"
      type="checkbox"
      class="me-2"
      [ngModel]="item$.selected"
      [ngModelOptions]="{ standalone: true }"
      (change)="$event.stopPropagation()" />
    {{ item.title }}
  </ng-template>
  <ng-template ng-multi-label-tmp>
    <span
      *ngIf="!currentSearchTerm"
      style="display: block"
      class="ng-placeholder"
      >{{ placeholder }}</span
    >
  </ng-template>
</ng-select>
<div
  *ngIf="loadingDistricts"
  class="fs-14 p-2 mt-2 d-flex justify-content-center align-items-center">
  <span
    class="spinner-border text-secondary spinner-border-sm me-2"
    role="status"
    aria-hidden="true"></span>
  Loading selected districts...
</div>
<ng-container
  *ngIf="
    !loadingDistricts &&
    internalSelectedDistrictList &&
    internalSelectedDistrictList.length
  ">
  <div>
    <ng-container *ngFor="let eachDistrict of visibleBadgeDistricts">
      <span
        class="badge badge-item mt-2 me-1"
        (click)="removeDistrictFromList(eachDistrict)"
        >{{ eachDistrict.title }}<i class="bi bi-x mx-2 me-2"></i
      ></span>
    </ng-container>
    <span
      *ngIf="badgeOverflowCount > 0"
      class="badge badge-item summary-badge mt-2 me-1 w-100"
      ngbTooltip="Show all selected districts"
      (click)="showAllSelectedBadges()">
      {{ internalSelectedDistrictList.length }} total selected
    </span>
  </div>
</ng-container>
